<template>

<div class="">
    <h1>No estás autorizado para estar aquí</h1>
</div>

</template>

